import { openUrl } from 'redux/app/actions'
import { copyToClipboard } from '../../helpers/clipboard'
import {
    getShareMailBody,
    getShareMailSubject,
    isSocialSharingOpened,
} from './selectors'
import { getCurrentMediaIIIFLocation } from '../currentMedia/selectors'
import { addSuccessAlert } from '../notifications/actions'
import { closeAllLeftAsides } from '../aside/actions'

export function toggleSocialSharing()
{
    return function toggleSocialSharing(dispatch, getState)
    {
        if(isSocialSharingOpened(getState()))
        {
            dispatch(closeSocialSharing())

            return
        }

        dispatch(openSocialSharing())
    }
}

export const OPEN_SOCIAL_SHARING = 'OPEN_SOCIAL_SHARING'
export function openSocialSharing()
{
    return function openSocialSharing(dispatch)
    {
        dispatch(closeAllLeftAsides())
        dispatch({ type: OPEN_SOCIAL_SHARING })
    }
}

export const CLOSE_SOCIAL_SHARING = 'CLOSE_SOCIAL_SHARING'
export const closeSocialSharing = () => ({
    type: CLOSE_SOCIAL_SHARING
})

export function share({parameters: urlGenerator}) {
    const url = urlGenerator(encodeURIComponent(window.location.href))
    return function(dispatch) {
        dispatch(openUrl(url))
    }
}

export function mail() {
    return function(dispatch, getState) {
        const body =  getShareMailBody(getState())
        const subject = getShareMailSubject(getState())

        dispatch(openUrl(`mailto:?subject=${subject}&body=${body}`))
    }
}

export function copyCurrentUrl({parameters}) {
    return function(dispatch) {
        copyToClipboard(window.location.href)
        if(parameters.message || null)
        {
            dispatch(addSuccessAlert(parameters.message))
        }
    }
}

export function copyIIIFUrl({parameters}) {
    return function(dispatch, getState) {
        copyToClipboard(getCurrentMediaIIIFLocation(getState()))
        if(parameters.message || null)
        {
            dispatch(addSuccessAlert(parameters.message))
        }
    }
}
